module.exports = __webpack_public_path__ + "img/booking2.c5208797.png";